import { setupFloatingPlaceholder } from './floating-placeholder';

export default function initFluentFormPlaceholder() {
    document.querySelectorAll('.form-style-handler').forEach(form => {
        const fields = form.querySelectorAll(
            'input[type="text"], input[type="email"], input[type="tel"], textarea'
        );

        fields.forEach(input => {
            const ph = input.getAttribute('placeholder');
            if (!ph) return;

            const content = input.closest('.ff-el-input--content');
            if (!content) return;

            const label = document.createElement('div');
            label.classList.add('cbdonna-input-label');
            label.textContent = ph;

            content.classList.add('cbdonna-input-wrap');
            content.appendChild(label);
            input.classList.add('cbdonna-input');
            input.removeAttribute('placeholder');

            setupFloatingPlaceholder(input, label);
        });
    });
}
